import { useQuery } from '@tanstack/react-query';
import { useLayoutEffect } from 'react';
import useIdentityStore from '@/store/IdentityStore';
import { getAuthUserInfo } from '../utils/aceIdentity';

export const AUTH_USER_INFO_QUERY_KEY = ['authUserInfo'] as const;

const useAuthUserInfo = () => {
  const setUserInfo = useIdentityStore((state) => state.setUserInfo);
  const clearUserInfo = useIdentityStore((state) => state.clearUserInfo);

  const userInfoQuery = useQuery({
    queryKey: AUTH_USER_INFO_QUERY_KEY,
    queryFn: getAuthUserInfo,
    staleTime: Number.POSITIVE_INFINITY,
  });

  useLayoutEffect(() => {
    if (userInfoQuery.data) {
      setUserInfo(userInfoQuery.data);
      return;
    }

    if (userInfoQuery.data === null) {
      clearUserInfo();
    }
  }, [userInfoQuery.data, setUserInfo, clearUserInfo]);

  return { userInfoQuery };
};

export default useAuthUserInfo;
